const STORAGE_KEY = 'articles_list'
export default {
fetch:function(){
  return JSON.parse(window.localStorage.getItem(STORAGE_KEY || '[]'))
},
save:function(items){
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items))
}
}



// WEBPACK FOOTER //
// ./src/storage.js